module.exports = __webpack_public_path__ + "img/IMG_0705.cd96d7ce.jpg";